
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 90 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#007a5e","d":"M0 0h30v60H0z"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M30 0h30v60H30z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M60 0h30v60H60z"}}),_c('g',{attrs:{"transform":"translate(45 30)","fill":"#fcd116"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-8v8h4z","transform":"rotate(18 0 -8)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})])])
          )
        }
      }
    